/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
import { MedicationForm } from './wasting.model';

export const COLLECTION_PROBABILITY_MIN = 0;
export const COLLECTION_PROBABILITY_MAX = 100;

export enum FormularyWitnessRequirement {
  'None' = 0,
  'InPerson' = 1,
  'Anytime' = 2,
  'AdminOverride' = 3,
}

export enum DEAScheduleKey {
  None,
  I,
  II,
  III,
  IV,
  V,
}

// DTO for central pharmacy samples, similar to Formulary
// Could possibly share common interface in future
export interface MedicationGroup {
  id: number;
  exitSafeRequired: boolean;
  isLiquid: boolean;
  isHazardous: boolean;
  medicationGroupDescription: string;
  witnessingRequirement: FormularyWitnessRequirement;
  deaSchedule: DEAScheduleKey;
  supplyForm: MedicationForm; // only for specific medication
  uoMs: UOM[];
  medication: MedicationV2 | null; // if specific medication was selected
  medications: MedicationV2[]; // for group queries
}

export interface MedicationV2 {
  id: number;
  adcMedId: string;
  medicationDescription: string;
  ehrMedId: string;
  supplyFormId: MedicationForm;
  ndc: string;
}

export interface UOM {
  id: number;
  description: string;
}

export interface ServiceList {
  id: number;
  name: string;
  medicationGroups: MedicationGroup[];
}

export interface UpsertServiceListRequest {
  id: number | null;
  name: string | null;
  medicationGroupIds: number[];
}

export function isBottle(medicationForm: MedicationForm) {
  return medicationForm === MedicationForm.Tablet || medicationForm === MedicationForm.Capsule;
}
